import Homepage from "./Homepage";
import System from "./System";
import Drive from "./Drive";
import Documents from "./Documents";
import Settings from "./Settings";
import FFDA from "./FFDA";
import Auth from "./Auth";
import Portals from "./Portals";
import Billing from "./Billing";

export default {
  Homepage,
  Drive,
  Settings,
  FFDA,
  Documents,
  // App System
  System,
  Auth,
  Portals,
  Billing,
};
